let navigateFunction: ((path: string) => void) | null = null;

export const setNavigateFunction = (navigate: (path: string) => void) => {
  navigateFunction = navigate;
};

export const navigateTo = (path: string) => {
  if (navigateFunction) {
    navigateFunction(path);
  } else {
    window.location.href = path;
  }
};

export const isValidRelativeRoute = (path: string = ''): boolean => {
  if (path === '/help' || path.startsWith('/help/')) return false;
  return (
    path.startsWith('/') && !path.startsWith('//') && !/^https?:\/\//.test(path)
  );
};

export const isAutoNavigateConfig = (): boolean => {
  return (
    localStorage.getItem(import.meta.env.VITE_LOCAL_STORAGE_SET_AUTON_NAV) ===
    'true'
  );
};
